const PredictionQueryKeys = {
  global: ["predictions"] as const,

  /**
   * Prediction Lists
   */
  list: (category: string, subCategory: string, query: string) =>
    [
      ...PredictionQueryKeys.global,
      "statuses",
      "list",
      category,
      subCategory,
      query,
    ] as const,

  /**
   * Prediction Details
   */
  details: () => [...PredictionQueryKeys.global, "details"] as const,
  prediction: (predictionId: string) =>
    [...PredictionQueryKeys.details(), predictionId] as const,
  game: (predictionId: string) =>
    [...PredictionQueryKeys.details(), predictionId, "game"] as const,
  chart: (predictionId: string) =>
    [...PredictionQueryKeys.details(), predictionId, "chart"] as const,
};

const PredictionCategoryQueryKeys = {
  global: ["predictionCategories"] as const,

  /**
   * Prediction Categories List
   */
  list: () => [...PredictionCategoryQueryKeys.global, "list"] as const,
};

export { PredictionQueryKeys, PredictionCategoryQueryKeys };
